import { OdometerHourmeterReportMessages, TranslationOdometerHourmeterReportMessages } from "../interfaces/odometerHourmeterReportMessages";

const odometerHourmeterReportMessages: TranslationOdometerHourmeterReportMessages = {
  [OdometerHourmeterReportMessages.title]: "Informe de Odómetro/Horómetro Total",
  [OdometerHourmeterReportMessages.startDateTime]: "Período Inicial",
  [OdometerHourmeterReportMessages.endDateTime]: "Período Final",
  [OdometerHourmeterReportMessages.date]: "Fecha",
  [OdometerHourmeterReportMessages.vehicleCode]: "Vehículo",
  [OdometerHourmeterReportMessages.vehicleDescription]: "Descripción",
  [OdometerHourmeterReportMessages.originalAllocation]: "Asignación Original",
  [OdometerHourmeterReportMessages.currentAllocation]: "Asignación Actual",
  [OdometerHourmeterReportMessages.totalOdometer]: "Odómetro Total (KM)",
  [OdometerHourmeterReportMessages.totalHourmeter]: "Horómetro Total (Horas)",
  [OdometerHourmeterReportMessages.dailyOdometer]: "Odómetro Diario (KM)",
  [OdometerHourmeterReportMessages.dailyHourmeter]: "Horómetro Diario (Horas)",
  [OdometerHourmeterReportMessages.noDataFound]: "No se encontraron datos para los filtros informados",
  [OdometerHourmeterReportMessages.invalidFilter]: "Filtro inválido. Informe al menos un criterio de identificación",
  [OdometerHourmeterReportMessages.success]: "Informe generado con éxito",
  [OdometerHourmeterReportMessages.error]: "Error al generar informe de odómetro/horómetro",
  [OdometerHourmeterReportMessages.invalidDateRange]: "Rango de fechas inválido. Máximo permitido: 30 días",
  [OdometerHourmeterReportMessages.fleet]: "Flota",
  [OdometerHourmeterReportMessages.selectVehicle]: "Seleccione el vehículo",
  [OdometerHourmeterReportMessages.allVehicles]: "Todos los vehículos"
};

export const messages = odometerHourmeterReportMessages;
